import script from "./Account.vue?vue&type=script&setup=true&lang=ts"
export * from "./Account.vue?vue&type=script&setup=true&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=e992fe8a&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e992fe8a"]])

export default __exports__